var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"chatapp-wrap"},[_c('MeldungsvorlageElementLeft'),_vm._v(" "),_c('div',{staticClass:"chatapp-right"},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }